// Bridge that lets non-React code (e.g. the global axios response interceptor)
// raise the same app notifications the UI uses. ErrorDisplayProvider registers
// its notify() here on mount.
let notifyFn = null;

export function setNotifier(fn) {
  notifyFn = fn;
}

export function notifyFromServer(message, severity) {
  if (notifyFn && message) {
    notifyFn(message, severity);
  }
}
